"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertUTCDateToLocalDate = exports.formatDate = exports.getDatefromAWSDateTime = exports.getTimefromAWSDateTime = exports.getDateFromTimestampZero = exports.resolveISODate = exports.formatAwsDateTime = exports.formatAwsDateStringAsDisplayDate = exports.getDateFromAwsDateString = exports.displayDateFormatMap = exports.UserDateDisplayPref = exports.formatAwsDatetoDisplayString = exports.getReportFormattedDate = exports.getTz = exports.getFormattedDayOfWeek = exports.dateFormatS3 = exports.getGenericDateFormat = exports.getInputDateFormat = exports.convertToISODate = exports.dateFormat = exports.getResolvedDate = exports.reportFormatMap = exports.inputDateFormatMap = exports.genericDateFormatMap = void 0;
var date_fns_1 = require("date-fns");
var date_fns_tz_1 = require("date-fns-tz");
exports.genericDateFormatMap = {
    mdy: "MM/dd/yyyy",
    dmy: "dd/MM/yyyy",
    ymd: "yyyy/MM/dd",
};
// TODO: only allow mdy | dmy | ymd as keys and fix below
exports.inputDateFormatMap = {
    mdy: "MMM d, yyyy",
    dmy: "d MMM, yyyy",
    ymd: "yyyy MMM d",
    mdy2: "MM/dd/yyyy",
    ymd2: "yyyy-MM-dd",
    dmy2: "dd/MM/yyyy",
};
/**
 * Map of date formats used for reports that need a more detailed date
 */
exports.reportFormatMap = {
    mdy: "MMMM d, yyyy",
    dmy: "d MMMM, yyyy",
    ymd: "yyyy MMMM, d",
};
/**
 * Expect date like format and attempt to validate and resolve it, returning an empty string if invalid
 */
var getResolvedDate = function (date) {
    if (!date)
        return "";
    var resolvedDate = date instanceof Date ? date : new Date(date);
    return resolvedDate.toISOString();
};
exports.getResolvedDate = getResolvedDate;
var dateFormat = function (date, formatOption) {
    var resolvedDate = (0, exports.getResolvedDate)(date);
    if (!resolvedDate)
        return "";
    return (0, date_fns_1.format)((0, date_fns_1.parseISO)(resolvedDate), exports.inputDateFormatMap[formatOption]);
};
exports.dateFormat = dateFormat;
var convertToISODate = function (dateString) {
    var date = new Date(dateString);
    return date.toISOString();
};
exports.convertToISODate = convertToISODate;
var getInputDateFormat = function (dateDisplayPref) {
    if (dateDisplayPref === void 0) { dateDisplayPref = "mdy"; }
    return exports.inputDateFormatMap[dateDisplayPref] || exports.inputDateFormatMap.mdy;
};
exports.getInputDateFormat = getInputDateFormat;
var getGenericDateFormat = function (dateDisplayPref) {
    if (dateDisplayPref === void 0) { dateDisplayPref = "mdy"; }
    return exports.genericDateFormatMap[dateDisplayPref] || exports.genericDateFormatMap.mdy;
};
exports.getGenericDateFormat = getGenericDateFormat;
/**
 * Used for pdf and perhaps other presigned urls
 */
var dateFormatS3 = function (date) {
    var dateToFormat = date || new Date();
    return (0, date_fns_tz_1.format)(dateToFormat, "MMMM d,Y h:mma z");
};
exports.dateFormatS3 = dateFormatS3;
var getFormattedDayOfWeek = function (dateString, formatOption) {
    if (formatOption === void 0) { formatOption = "EEE"; }
    var date = new Date(dateString).toString();
    return (0, date_fns_1.format)((0, date_fns_1.getDay)(new Date(date)), formatOption);
};
exports.getFormattedDayOfWeek = getFormattedDayOfWeek;
/**
 * Get abbreviated timezone string if it can be resolved, otherwise
 */
var getTz = function (date) {
    var _a, _b;
    var resolvedDate = date || new Date();
    var _c = (((_a = Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat()) === null || _a === void 0 ? void 0 : _a.resolvedOptions()) || {}).locale, locale = _c === void 0 ? "en-us" : _c;
    return (((_b = resolvedDate
        .toLocaleTimeString(locale, { timeZoneName: "short" })) === null || _b === void 0 ? void 0 : _b.split(" ")[2]) || "");
};
exports.getTz = getTz;
/**
 * Format date string for pdf reports
 */
var getReportFormattedDate = function (date, dateDisplayPref) {
    if (dateDisplayPref === void 0) { dateDisplayPref = "mdy"; }
    var resolvedDate = date || new Date();
    // const tz = getTz(resolvedDate);
    var pattern = exports.reportFormatMap[dateDisplayPref] || exports.genericDateFormatMap.mdy;
    var formattedDateString = (0, date_fns_1.format)(resolvedDate, pattern);
    return "".concat(formattedDateString).trim();
};
exports.getReportFormattedDate = getReportFormattedDate;
/**
* Convert AWS formated date (2022-12-25) into date string using display preferences from user
  Example : if the user preference is mdy the output of this functions is 12/25/2022
*/
var formatAwsDatetoDisplayString = function (date, dateDisplayPref) {
    if (dateDisplayPref === void 0) { dateDisplayPref = "mdy"; }
    var _a = date.split("-"), year = _a[0], month = _a[1], day = _a[2];
    switch (dateDisplayPref) {
        case "mdy":
            return "".concat(month, "/").concat(day, "/").concat(year);
        case "dmy":
            return "".concat(day, "/").concat(month, "/").concat(year);
        case "ymd":
            return "".concat(year, "/").concat(month, "/").concat(day);
        default:
            return "".concat(month, "/").concat(day, "/").concat(year);
    }
};
exports.formatAwsDatetoDisplayString = formatAwsDatetoDisplayString;
/** collection of date display preferences */
var UserDateDisplayPref;
(function (UserDateDisplayPref) {
    UserDateDisplayPref["MDY"] = "mdy";
    UserDateDisplayPref["DMY"] = "dmy";
    UserDateDisplayPref["YMD"] = "ymd";
})(UserDateDisplayPref = exports.UserDateDisplayPref || (exports.UserDateDisplayPref = {}));
/**
 * Formats used for date display purposes (reports, views, etc)
 */
exports.displayDateFormatMap = {
    mdy: "MM/dd/yyyy",
    dmy: "dd/MM/yyyy",
    ymd: "yyyy/MM/dd",
};
/**
 * Get a date using AWS date format yyyy/MM/dd or return null
 */
var getDateFromAwsDateString = function (dateString) {
    try {
        var resolvedDate = (0, date_fns_1.parse)(dateString, "yyyy-MM-dd", new Date());
        if ((0, date_fns_1.isValid)(resolvedDate))
            return resolvedDate;
    }
    catch (ex) {
        // eslint-disable-next-line no-console
        console.error("unable to parse date");
    }
    return null;
};
exports.getDateFromAwsDateString = getDateFromAwsDateString;
/**
 * Format an AWS date string using user date display preferences
 */
var formatAwsDateStringAsDisplayDate = function (dateString, pref) {
    if (pref === void 0) { pref = UserDateDisplayPref.MDY; }
    var resolvedDate = (0, exports.getDateFromAwsDateString)(dateString);
    if (!resolvedDate)
        return null;
    return (0, date_fns_1.format)(resolvedDate, exports.displayDateFormatMap[pref] || exports.displayDateFormatMap[UserDateDisplayPref.MDY]);
};
exports.formatAwsDateStringAsDisplayDate = formatAwsDateStringAsDisplayDate;
// formats AWSDateTime ex: 2022-07-14T15:39:25.378Z to genericDateFormatMap
var formatAwsDateTime = function (date, displayPref) {
    if (displayPref === void 0) { displayPref = "mdy"; }
    return (0, date_fns_1.format)(new Date(date), exports.genericDateFormatMap[displayPref]);
};
exports.formatAwsDateTime = formatAwsDateTime;
/**
 * Attempt to resolve ISO date or return undefined
 */
var resolveISODate = function (date) {
    return date ? (0, exports.convertToISODate)(date) : undefined;
};
exports.resolveISODate = resolveISODate;
/**
 * @param date
 * @param dateDisplayPref
 * @returns date (avoiding day off less)
 */
var getDateFromTimestampZero = function (date, dateDisplayPref) {
    if (dateDisplayPref === void 0) { dateDisplayPref = "ymd"; }
    return (0, exports.formatAwsDatetoDisplayString)(date.split("T")[0], dateDisplayPref);
};
exports.getDateFromTimestampZero = getDateFromTimestampZero;
/**
 * Get time from AWSDateTime
 * @param date
 * @returns Time of the date (hh:mm)
 */
// create getTimeFromAWSDateTime
var getTimefromAWSDateTime = function (date) {
    return new Date(date).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
    });
};
exports.getTimefromAWSDateTime = getTimefromAWSDateTime;
var getDatefromAWSDateTime = function (date) {
    return new Date(date).toLocaleString("en-US");
};
exports.getDatefromAWSDateTime = getDatefromAWSDateTime;
var formatDate = function (date, formatOption) {
    if (!date)
        return "";
    var dateToFormat = (0, exports.convertToISODate)((0, exports.getDateFromTimestampZero)(date));
    return (0, date_fns_1.format)((0, date_fns_1.parseISO)(dateToFormat), formatOption);
};
exports.formatDate = formatDate;
/**
 * Convert UTC date to local date keeping ISO format
 *
 * 2023-03-06T14:15:38.664Z ( UTC ) => 2023-03-06T06:15:38.664Z ( PST )
 *
 * @param date
 * @returns date in local zone in ISO format
 */
var convertUTCDateToLocalDate = function (date) {
    var localDateIsoFormat = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000).toISOString();
    return localDateIsoFormat;
};
exports.convertUTCDateToLocalDate = convertUTCDateToLocalDate;
